/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.form_submit.init());


App.form_submit = {

  init() {
    return $(document)
      .off("click", "button[data-submit-for], input[data-submit-for]", this.clicked)
      .on("click", "button[data-submit-for], input[data-submit-for]", this.clicked);
  },


  clicked(evt) {
    const $form = $( $(this).data("submit-for") );
    return $form.submit();
  }
};
